import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Switch } from "antd";
import { useI18n } from "../../../../../contexts/i18n.js";
import { FormContentBlockerLayout } from "../../../layout.js";
const FormContentBlockerFieldShouldForceToShowVisual = ()=>{
    const { __ } = useI18n();
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>prevValues.isVisual !== nextValues.isVisual,
        children: ({ getFieldValue })=>{
            const isVisual = getFieldValue("isVisual");
            return !!isVisual && /*#__PURE__*/ _jsx(Form.Item, {
                wrapperCol: {
                    offset: FormContentBlockerLayout.labelCol.span
                },
                children: /*#__PURE__*/ _jsxs("span", {
                    children: [
                        /*#__PURE__*/ _jsx(Form.Item, {
                            name: "shouldForceToShowVisual",
                            valuePropName: "checked",
                            noStyle: true,
                            children: /*#__PURE__*/ _jsx(Switch, {})
                        }),
                        "\xa0\xa0",
                        __("Force visual content blocker for hidden elements"),
                        /*#__PURE__*/ _jsx("p", {
                            className: "description",
                            children: __("In rare cases, visual content blockers are not displayed because the main element of the blocked content is not visible either. Enable this option if this is the case and you want to force to display a content blocker for non-visible elements.")
                        })
                    ]
                })
            });
        }
    });
};
export { FormContentBlockerFieldShouldForceToShowVisual };
